export const texts = {
	werberat: {
		mail: 'office@werberat.at',
		companyname: 'Österreichischer Werberat',
		dsgvo:
			'Bitte bestätigen Sie, dass wir Ihre Daten zur Bearbeitung Ihrer Beschwerde speichern und verarbeiten und Sie für diesen Zweck via Mail kontaktieren dürfen.',
		dsgvoLinktext: 'Unsere Datenschutzbestimmungen finden Sie hier.',
		dsgvoHinweis: 'Bitte schließen Sie dieses Fenster während des Datei-Uploads nicht.',
	},
	formErrors: {
		reqMissing: 'Dieses Feld ist ein Pflichtfeld.',
		loginFailed: 'Falscher Username oder falsches Passwort. Bitte versuchen Sie es erneut.',
		loginSuccess: 'Sie wurden erfolgreich eingeloggt',
		logoutFailed: 'Logout hat leider nicht funktioniert.',
		pwResetFailed: 'Es gab ein Problem beim Setzen Ihres Passworts. Bitte lassen Sie sich einen neuen Link zusenden.',
		pwResetSuccess: 'Passwort erfolgreich gesetzt!',
		emailReq: 'Bitte geben Sie Ihre E-Mail an.',
		emailMissing: 'Bitte geben Sie eine korrekte E-Mail an.',
		dateRangeMissing: 'Bitte wählen Sie einen Zeitraum aus.',
		timeMissing: 'Bitte wählen Sie eine Uhrzeit aus.',
		endtimeMissing: 'Bitte wählen Sie eine Endzeit aus.',
		pwReq: 'Bitte geben Sie Ihr Passwort an.',
		pwNoMatch: 'Die Passwörter stimmen nicht überein.',
		pwInvalid:
			'Für ein möglichst sicheres Passwort verwenden Sie bitte mindestens einen Groß- und Kleinbuchstaben, sowie jeweils ein Sonderzeichen und eine Zahl.',
		newTodoItemFailed: 'Das hat leider nicht funktioniert. Bitte versuchen Sie es später noch einmal',
		minChars: 'Ihre Eingabe ist zu kurz.',
		maxChars: 'Ihre Eingabe ist zu lang.',
		contactMissing: 'Bitte geben Sie einen Kontakt an.',
		genderMissing: 'Bitte wählen Sie die Anrede aus.',
		titleMissing: 'Bitte geben Sie den Titel an.',
		categoryMissing: 'Dieses Feld ist ein Pflichtfeld. Bitte wählen Sie den Beschwerdegrund.',
		mediumMissing: 'Dieses Feld ist ein Pflichtfeld. Bitte wählen Sie ein Medium.',
		userRoleMissing: 'Bitte weisen Sie mindestens 1 Rolle zu.',
		decisionCategoryMissing: 'Bitte wählen Sie mindestens eine Kategorie aus.',
		decisionMissing: 'Bitte treffen Sie eine Entscheidung.',
		waiting: 'Ihre Daten werden verarbeitet. Bitte haben Sie einen Moment Geduld.',
		waitingForUpload: 'Upload ausstehend, bitte speichern.',
		pwResendSuccess: 'Ein neuer Link wurde an Ihre E-Mail-Adresse gesendet. Bitte überprüfen Sie Ihren Posteingang.',
		pwResendFailed: 'Es gab ein Problem beim Senden des Links. Bitte versuchen Sie es später noch einmal.',
	},
	table: {
		emptyText: 'Keine Daten vorhanden',
	},
	todolist: {
		emptyText: 'Nichts zu tun...',
	},
	general: {
		emptyText: 'Daten konnten leider nicht geladen werden.',
		emptyMedia: 'Keine Medien vorhanden.',
		emptyLinks: 'Keine externen Links vorhanden.',
		deleteFileFailed: 'Löschen der Datei hat leider nicht funktioniert.',
		deleteFileSuccess: 'Die Datei wurde gelöscht.',
		deleteLinkSuccess: 'Der Link wurde gelöscht.',
		deleteLinkFailed: 'Löschen des Links hat leider nicht funktioniert.',
	},
	complaints: {
		editFailed: 'Die Beschwerde konnte nicht bearbeitet werden.',
		saveFailed: 'Die Beschwerde konnte nicht gespeichert werden.',
		saveSuccess: 'Die Beschwerde wurde gespeichert.',
		publishFailed: 'Die Beschwerde konnte nicht veröffentlicht werden.',
		deleteFailed: 'Die Beschwerde konnte nicht gelöscht werden.',
		assignToCaseFailed: 'Die Beschwerde konnte dem Fall leider nicht zugeordnet werden.',
		createCaseFailed: 'Die Fall konnte nicht erstellt werden.',
	},
	cases: {
		editFailed: 'Der Fall konnte nicht bearbeitet werden.',
		saveFailed: 'Der Fall konnte nicht gespeichert werden.',
		saveSuccess: 'Der Fall wurde gespeichert.',
		smallSenateGetterFailed: 'Der zuständige Senat konnte nicht ermittelt werden.',
		publishFailed: 'Der Fall konnte nicht veröffentlicht werden.',
		publishSuccess: 'Der Fall wurde veröffentlicht.',
		unpublishSuccess: 'Der Fall wurde nicht veröffentlicht.',
		deleteFailed: 'Der Fall konnte nicht gelöscht werden.',
		preliminaryDecisionFailed: 'Vorzeitige Entscheidung konnte nicht gespeichert werden.',
	},
	callbacks: {
		saveFailed: 'Die Rückfrage konnte nicht gespeichert werden.',
	},
	statements: {
		saveFailed: 'Die Stellungnahme konnte nicht gespeichert werden.',
		saveSuccess: 'Die Stellungnahme wurde gespeichert.',
		saveSendSuccess: 'Die Stellungnahme wurde erfolgreich verschickt.',
		createFailed: 'Die Stellungnahme konnte nicht erstellt werden.',
		deadlineExtensionFailed: 'Die Frist konnte nicht verlängert werden.',
		deleteFailed: 'Die Stellungnahme konnte nicht gelöscht werden.',
	},
	user: {
		createContactFailed: 'Der Kontakt konnte nicht erstellt werden.',
		saveContactFailed: 'Der Kontakt konnte nicht gespeichert werden.',
		saveContactSuccess: 'Der Kontakt wurde gespeichert.',
		createUserFailed: 'Der User konnte nicht erstellt werden.',
		emailExists: 'Es existiert bereits ein User mit dieser E-Mail.',
		emailExistsContact: 'Es existiert bereits ein Kontakt mit dieser E-Mail.',
		saveUserFailed: 'Der User konnte nicht gespeichert werden.',
		saveUserSuccess: 'Der User wurde gespeichert.',
		setAbsenceFailed: 'Die Abwesenheit konnte leider nicht gespeichert werden.',
		activationFailed: 'Der User konnte leider nicht aktiviert werden.',
		deactivationFailed: 'Der User konnte leider nicht deaktiviert werden.',
		addRoleFailed: 'Die neue Gruppe konnte leider nicht hinzugefügt werden.',
		removeRoleFailed: 'Die Gruppe konnte leider nicht entfernt werden.',
	},
	decisions: {
		saveFailed: 'Die Entscheidung konnte leider nicht gespeichert werden.',
	},
};

export const translateToGerman = (text: String) => {
	switch (text) {
		case 'Complaint already marked as not responsible':
			return 'Diese Beschwerde ist bereits als nicht zuständig markiert.';
		case 'Complaint already has a case':
			return 'Diese Beschwerde ist schon einem Fall zugewiesen.';
		case 'User has already set a password.':
			return 'Dieser User scheint bereits bestätigt zu sein. Bitte versuchen Sie sich einzuloggen.';
		default:
			return;
	}
};
